import { render, staticRenderFns } from "./MoonLandingPageNew.vue?vue&type=template&id=589eb319&scoped=true"
import script from "./MoonLandingPageNew.vue?vue&type=script&lang=js"
export * from "./MoonLandingPageNew.vue?vue&type=script&lang=js"
import style0 from "./MoonLandingPageNew.vue?vue&type=style&index=0&id=589eb319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589eb319",
  null
  
)

export default component.exports